import React, { useContext, useEffect, useMemo } from 'react';
import { useTransactionServerSide } from '../hooks/useTransactionsServerSide';

export const TransactionServerSideContext = React.createContext()

export const TransactionServerSideProvider = ({ children }) => {
    const transactionServerSideState = useTransactionServerSide();
    const value = useMemo(() => transactionServerSideState, [transactionServerSideState])

    //useEffect(() => { console.log("TransactionServerSideProvider => ", value) }, [value])

    return (
        <TransactionServerSideContext.Provider value={value}>
            {children}
        </TransactionServerSideContext.Provider>
    );
}

export function useTransactionServerSideContext() {
    return useContext(TransactionServerSideContext)
}
